export function tarOlvas(kulcs: string): string | null {
  try {
    return localStorage.getItem(kulcs);
  } catch {
    // Szándékosan elnyelt hiba: privát módban vagy tiltott tárhelynél a localStorage nem elérhető; ilyenkor nincs mentett érték.
    return null;
  }
}

export function tarIr(kulcs: string, ertek: string): void {
  try {
    localStorage.setItem(kulcs, ertek);
  } catch {
    // Szándékosan elnyelt hiba: ha a tárhely nem elérhető, a választás csak a munkamenet erejéig él.
  }
}
